import { Component, ViewChild, OnInit, OnDestroy, HostListener } from "@angular/core";
import { App, Nav, NavController, Platform } from "ionic-angular";
import { StatusBar } from "@ionic-native/status-bar";
import { Storage } from "@ionic/storage";
import { SplashScreen } from "@ionic-native/splash-screen";
import { ApiProvider } from "../providers/api/api";
import { VersionProvider } from "../providers/version/version";
import { AlertController } from "ionic-angular";
import { NotificationProvider } from "../providers/notification/notification";
import { CompanyProvider } from "../providers/company/company";
import { Subscription } from "rxjs/Subscription";
import { Company } from "../models/company";

@Component({
	templateUrl: "app.component.html"
})
export class AppComponent implements OnInit, OnDestroy {
	/* Getters */

	get navCtrl(): NavController {
		return this.app.getRootNav();
	}

	/* Listeners */

	@HostListener("document:fullscreenchange", ["$event"])
	@HostListener("document:webkitfullscreenchange", ["$event"])
	@HostListener("document:mozfullscreenchange", ["$event"])
	@HostListener("document:MSFullscreenChange", ["$event"])
	screenChange() {
		this.fullscreen = !!(document["fullscreenElement"] || document["mozFullScreenElement"] || document["webkitFullscreenElement"]);

		this.fullScreenBtnText = this.fullscreen ? "Minimera" : "Helskärm";
	}

	@ViewChild(Nav) nav: Nav;

	public rootPage = "HomePage";

	public fullscreen: boolean = false;

	private documentElement;

	private company$: Subscription;

	private isTimeOfBirthFormatParameter$: Subscription;

	private company: Company;

	public isTimeOfBirthFormatParameter: boolean = false;

	public workplaceTitle = "";

	public companyName = "";

	public scheduleIsVisible: boolean = false;

	public fullScreenBtnText: string = "Helskärm";

    public checkinMethods: Record<"GRID" | "KEYPAD", string> = { GRID: "GRID", KEYPAD: "KEYPAD" }

	public currentVersion: string;

	public isStandalone: boolean = false;

	constructor(protected app: App, protected platform: Platform, protected alertController: AlertController, public api: ApiProvider, public storage: Storage, public alertCtrl: AlertController, public notif: NotificationProvider, public statusBar: StatusBar, public splashScreen: SplashScreen, private companyProvider: CompanyProvider, private versionProvider: VersionProvider) {
		this.documentElement = document.documentElement;

		this.backButtonListener();
	}

	public ngOnInit(): void {
		this.platformReady();

		this.currentVersion = this.versionProvider.currentVersion;

		this.subscribeToNavParams();

		if(window && 'matchMedia' in window && typeof window.matchMedia === 'function') {
			this.isStandalone = window.matchMedia('(display-mode: standalone)').matches;
		}

		this.company$ = this.companyProvider.company.subscribe(company => {
			if (!company) {
				return;
			};

			this.company = company;

			this.scheduleIsVisible = this.company.scheduleIsVisible;

			if (this.company.workplaceId != null) {
				this.workplaceTitle = this.company.workplaceTitle;
				this.companyName = this.company.companyName;
			} else {
				this.workplaceTitle = this.company.companyName;
				this.companyName = "";
			}
		});

		this.versionProvider.newVersionAvailableSubject.subscribe(async hash => {
			const alert = this.alertController.create({
				title: "Ny version är tillgänglig!",
				subTitle: "Vänligen ladda om sidan.",
				buttons: [
					{
						text: "Avbryt",
						role:"cancel"
					},
					{
						text: "Ladda Om",
						handler: () => {
							window.location.reload();
						}
					}
				],
				enableBackdropDismiss: false,
				cssClass: "version-alert"
			});

			await alert.present();
		})

		// have to do this here because versionProvider is initialized before this component
		// otherwise we would miss initial check
		this.versionProvider.initVersionCheck();
	}

	public ngOnDestroy() {
		this.company$.unsubscribe();

		this.isTimeOfBirthFormatParameter$.unsubscribe();
	}

    public toggleHomePage() {
        this.navCtrl.setRoot("HomePage", { isTimeOfBirthFormat: !this.isTimeOfBirthFormatParameter }, { animate: true, direction: "forward" });
    }

	private subscribeToNavParams(): void {
		// Set up subscription to track navigation events
		this.isTimeOfBirthFormatParameter$ = this.app.viewWillEnter.subscribe((application) => {
			if(application !== undefined && application.instance !== undefined && application.instance.navParams !== undefined && application.instance.navParams.data !== undefined) {
				if(application.instance.navParams.data.isTimeOfBirthFormat !== undefined) {
					this.isTimeOfBirthFormatParameter = application.instance.navParams.data.isTimeOfBirthFormat;
				}
				else {
					this.isTimeOfBirthFormatParameter = false;
				}
			}
		});
	}

	private backButtonListener(): void {
		window.onpopstate = () => {
			const activeModalPortal = this.app._appRoot._modalPortal.getActive();

			if (activeModalPortal) {
				activeModalPortal.dismiss();
			}
		}
	}

	private platformReady() {
		this.platform.ready().then(() => {
			if(this.platform.is("cordova")) {
				this.statusBar.styleDefault();

				this.splashScreen.hide();
			}
		});
	}

	navigateToPage(page) {
		this.navCtrl.setRoot(page, {}, { animate: true, direction: "forward" });
	}

	logoutWorkplace() {
		let alert = this.alertCtrl.create({
			title: "Bekräfta utloggning",
			message: "Är du säker att du vill logga ut från arbetsplatsen?",
			buttons: [
				{ text: "Nej", role: "cancel", handler: () => { } },
				{
					text: "Ja", handler: () => {
						this.companyProvider.logout().then(() => {
							this.navigateToPage("LoginPage");

							this.notif.showSuccessMessage("Arbetsplatsen har nu loggat ut."); // FIXME_CLOCKAPI @Ludwig better text here, perhaps?
						});
					}
				}
			]
		});

		alert.present();
	}

	public toggleFullScreen() {
		if (!this.fullscreen) {
			if (this.documentElement.webkitRequestFullscreen) {
				this.documentElement.webkitRequestFullscreen();
			}
			else if (this.documentElement.requestFullscreen) {
				this.documentElement.requestFullscreen();
			}
		} else {
			if (document["webkitCancelFullScreen"]) {
				document["webkitCancelFullScreen"]();
			}
			else if (document.exitFullscreen) {
				document.exitFullscreen();
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts